import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Rating, TextField, Box } from "@mui/material";
import { teal } from "@mui/material/colors";
import { useAppDispatch } from "../../../State/Store";
import { createProductReview } from "../../../State/customer/reviewSlice";

export interface CreateReviewModalProps {
  open: boolean;
  onClose: () => void;
  productId: number;
}

const CreateReviewModal: React.FC<CreateReviewModalProps> = ({ open, onClose, productId }) => {
  const [rating, setRating] = useState<number | null>(5);
  const [reviewText, setReviewText] = useState("");
  const dispatch = useAppDispatch();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const jwt = localStorage.getItem("jwt");

    if (!rating || !reviewText.trim()) return;

    dispatch(
      createProductReview({
        jwt,
        request: {
          productId,
          reviewRating: rating, // Updated to match CreateReviewRequest interface
          reviewText,
          productImages: [],
        },
      })
    );
    onClose();
    setReviewText("");
    setRating(5);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 700, color: "#1f2937" }}>Write a Product Review</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers className="space-y-4">
          <Box className="flex flex-col items-center gap-2 py-2">
            <span className="text-sm font-medium text-gray-600">Rate this product</span>
            <Rating
              name="product-rating"
              value={rating}
              precision={1}
              size="large"
              onChange={(_, newValue) => setRating(newValue)}
            />
          </Box>

          <TextField
            fullWidth
            multiline
            rows={4}
            label="Write your feedback..."
            variant="outlined"
            value={reviewText}
            onChange={(e) => setReviewText(e.target.value)}
            required
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} color="inherit">
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={!rating || !reviewText.trim()}
            sx={{
              bgcolor: teal[600],
              "&:hover": { bgcolor: teal[700] },
              textTransform: "none",
            }}
          >
            Submit Review
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateReviewModal;